import React from 'react';
import PropTypes from 'prop-types';
import logo from '../../resources/images/logo.png';
import Paper from 'material-ui/Paper';
import './style.css';

function Header() {
  return (
    <Paper className="Header">
      <img src={logo} alt="Idaho High School Activities Association" />
    </Paper>
  );
}

export default Header;


// WEBPACK FOOTER //
// ./src/components/Header/index.js